// removed by extract-text-webpack-plugin
module.exports = {"SlideIn":"JdE3CID47OHP42kRWJG2G","SlideIn--visible":"lgS_v1LJFibAiyQL5dKSj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SlideIn/SlideIn.scss
// module id = 2450
// module chunks = 0